import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "row"]

  addRow() {
    const index = this.rowTargets.length
    const row = document.createElement("div")
    row.className = "flex gap-2 items-center"
    row.setAttribute("data-pdp-tax-split-target", "row")
    row.innerHTML = `
      <input type="number" step="0.01"
        name="transaction_batch[fields][tax_split][${index}][total_net]"
        placeholder="Kwota netto"
        class="w-1/3 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
      <input type="number" step="0.01"
        name="transaction_batch[fields][tax_split][${index}][tax]"
        placeholder="Stawka VAT (%)"
        class="w-1/3 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
      <input type="number" step="1"
        name="transaction_batch[fields][tax_split][${index}][count]"
        placeholder="Liczba"
        class="w-1/4 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
      <button type="button" data-action="pdp-tax-split#removeRow"
        class="text-red-500 hover:text-red-700 text-sm">✕</button>
    `
    this.rowsTarget.appendChild(row)
    this.reindexRows()
  }

  removeRow(event) {
    event.target.closest("[data-pdp-tax-split-target='row']").remove()
    this.reindexRows()
  }

  reindexRows() {
    this.rowTargets.forEach((row, index) => {
      row.querySelectorAll("input[name]").forEach(input => {
        input.name = input.name.replace(/\[\d+\]/, `[${index}]`)
      })
    })
  }
}
